
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    value: String,
    output: String,
    error: String,
    label: String,
    required: Boolean,
    onInput: Function,
    isTextarea: Boolean,
  },

  setup() {
    // const onClick = (e: Event) => {
    //   e.preventDefault();
    //   e.stopPropagation();
    // };
    const onFocus = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      setTimeout(() => {
        ((e.target as HTMLElement).parentElement as HTMLElement).scrollIntoView({ behavior: 'smooth' });
      }, 666);
    };
    return {
      // onClick,
      onFocus,
    };
  },
});
